import { createApp } from 'vue'
import GamesHub from '../components/GamesHub.vue'

export function mountGames() {
  const el = document.getElementById('games-app')
  if (!el) return

  const app = createApp(GamesHub)
  app.mount(el)
}
